import React from 'react';
import ToggleSelect from '../ToggleSelect';
import '../DotSelect/DotSelect.css';

function TreatmentQueue({ boxes, data, onToggle, toggledBoxes }) {
  return (
    <div className="selectedList">
      <div className="listHeader">{data.treatmentQueueHeader}</div>
      {toggledBoxes.map((t, i) => {
        return (
          <div className="listItemWrapper" key={i}>
            <p className="listItem">{boxes[t].title}</p>
            <div className="inlineToggle">
              <ToggleSelect isSelected onClick={() => onToggle(false, t)} />
            </div>
          </div>
        );
      })}
    </div>
  );
}

export default TreatmentQueue;
